import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackLoginParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackLogin";

const useTrackLogin = (parameters: TrackLoginParameters = {}, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.util.getEventTrackerHook(ga.track.login, parameters, options);
};

export default useTrackLogin;
